import React from "react";
import { Box, Link, IconButton } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useTranslation } from "react-i18next";
import { downloadChatMedia, filenameFromMediaUrl } from "../../utils/downloadChatMedia";

const DocumentMessage = ({ message }) => {
  const { t } = useTranslation("chat");
  const url = message?.url || (typeof message?.document === "string" ? message.document : message?.document?.url || message?.document?.link);
  const name = message?.name || message?.document?.name || message?.document?.fileName || message?.document?.filename || "Documento";
  if (!url || !String(url).trim()) return null;
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <Link href={url} target="_blank" rel="noopener noreferrer">
        {name}
      </Link>
      <IconButton
        size="small"
        aria-label={t("webchat.downloadAria")}
        onClick={(e) => {
          e.preventDefault();
          downloadChatMedia(url, name || filenameFromMediaUrl(url, "arquivo"));
        }}
      >
        <DownloadIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default DocumentMessage;
